import { render, staticRenderFns } from "./SubscriptionBoxOrderProductionBatches.vue?vue&type=template&id=5cff4aca&lang=pug&"
import script from "./SubscriptionBoxOrderProductionBatches.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SubscriptionBoxOrderProductionBatches.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports